import { Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';
import { FtcAttributeEditService } from './ftc-attribute-edit.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  gridPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { AppkitDropdownItem } from '../../../shared/utils/appkit-dropdown.util';
import {
  handleNamedDropdownSelect,
  refreshNamedDropdown,
  setFormDropdownAriaLabel
} from '../../shared/ftc-form-dropdown.support';

@Component({
    selector: 'gtw-ftc-attribute-edit',
    templateUrl: './ftc-attribute-edit.component.html',
    styleUrls: ['./ftc-attribute-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FtcAttributeEditComponent implements OnInit, OnDestroy {
  setFormDropdownAriaLabel = setFormDropdownAriaLabel;
  transCategoryDataView: AppkitDropdownItem[] = [];
  basketCodeDataView: AppkitDropdownItem[] = [];
  sicCodeDataView: AppkitDropdownItem[] = [];
  fdiiCodeDataView: AppkitDropdownItem[] = [];
  filteredTaxYearDataView: AppkitDropdownItem[] = [];
  lineNoCodeDataView: AppkitDropdownItem[] = [];
  yesNoDataView: AppkitDropdownItem[] = [];
  beatTypeDataView: AppkitDropdownItem[] = [];
  relatedCodeDataView: AppkitDropdownItem[] = [];
  tradingPartnerOptionsView: AppkitDropdownItem[] = [];
  countryCodeDataView: AppkitDropdownItem[] = [];
  htkoDataView: AppkitDropdownItem[] = [];
  fsiDataView: AppkitDropdownItem[] = [];
  sourceTypeCodeDataView: AppkitDropdownItem[] = [];
  projectTagCodeDataView: AppkitDropdownItem[] = [];
  methodCodeDataView: AppkitDropdownItem[] = [];
  baseFDIIDataView: AppkitDropdownItem[] = [];
  basketCodeAllocateDataView: AppkitDropdownItem[] = [];
  baseLevelDataView: AppkitDropdownItem[] = [];
  baseEntityDataView: AppkitDropdownItem[] = [];
  selectedTransCatItem: AppkitDropdownItem | null = null;
  selectedBasketCodeItem: AppkitDropdownItem | null = null;
  selectedSicCodeItem: AppkitDropdownItem | null = null;
  selectedFdiiCodeItem: AppkitDropdownItem | null = null;
  applicableYearKeyItem: AppkitDropdownItem | null = null;
  selectedLineNoItem: AppkitDropdownItem | null = null;
  selectedBeatCodeItem: AppkitDropdownItem | null = null;
  selectedBeatTypeCodeItem: AppkitDropdownItem | null = null;
  selectedRelatedCodeItem: AppkitDropdownItem | null = null;
  selectedTradingPartnerCodeItem: AppkitDropdownItem | null = null;
  selectedCountryCodeItem: AppkitDropdownItem | null = null;
  selectedHtkoCodeItem: AppkitDropdownItem | null = null;
  selectedFsiCodeItem: AppkitDropdownItem | null = null;
  selectedSourceTypeCodeItem: AppkitDropdownItem | null = null;
  selectedProjectTaggingCodeItem: AppkitDropdownItem | null = null;
  selectedMethodCodeItem: AppkitDropdownItem | null = null;
  selectedBaseFdiiCodesItem: AppkitDropdownItem | null = null;
  selectedBaseBasketCodeItem: AppkitDropdownItem | null = null;
  selectedBaseLevelCodeItem: AppkitDropdownItem | null = null;
  selectedBaseEntityLevelCodeItem: AppkitDropdownItem | null = null;

  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();
  private isInitialized = false;
  GENERAL_CONFIG: any = {};
  private globalParams: any = {};
  filterParams: any = {};
  private userSettings: any = {};

  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  loadingData = true;
  isError = false;

  logged_in_user = '';
  curentyear = '';
  scenario = '';
  jcd_key: any;
  QARScenario = 'N';

  // Grid data
  gridDataMultipleSelect: any = {};
  selectedAttributeRow: any[] = [];
  rowData: any;

  // Trans Category
  transCategoryData: any[] = [];
  selectedTransCat: any;

  // Dynamic field visibility
  newArray: string[] = [];
  getAttribToDisplay: any[] = [];

  // Dropdown data from code mast (31hizx)
  codeMastDataTempData: any;
  basketCodeData: any[] = [];
  basketCodeAllocateData: any[] = [];
  sicCodeData: any[] = [];
  fdiiCodeData: any[] = [];
  taxYearData: any[] = [];
  filteredTaxYearData: any[] = [];
  sourceTypeCodeData: any[] = [];
  projectTagCodeData: any[] = [];
  yesNoData: any[] = [];
  beatTypeData: any[] = [];
  relatedCodeData: any[] = [];
  countryCodeData: any[] = [];
  htkoData: any[] = [];
  fsiData: any[] = [];
  baseFDIIData: any[] = [];
  baseFDIIDataCopy: any[] = [];
  baseBasketData: any[] = [];
  baseBasketDataCopy: any[] = [];
  baseLevelData: any[] = [];
  baseEntityData: any[] = [];
  baseBasketTypeData: any[] = [];
  basefdiiSingleMultiData: any[] = [];
  baseTypeCodeData: any[] = [];
  lineNoCodeData: any[] = [];
  methodCodeData: any[] = [];
  attribMastData: any[] = [];
  allTransCategoryData: any[] = [];
  allGPTransCategoryData: any[] = [];
  baseTypeData: any[] = [];
  dropdownLists: { [k: string]: any[] } = { baseFDII: [], baseBasket: [], baseType: [] };
  baseTypeDataCopy: any[] = [];
  tradingPartnerCodeData: any[] = [];
  beatYesforeignTradingPartnerData: any[] = [];
  beatNoforeignTradingPartnerData: any[] = [];
  domesticTradingPartnerData: any[] = [];
  fseCompDefaultData: any[] = [];
  allDefaultData: any[] = [];
  singleBaseFDIIData: any[] = [];
  singleBaseBasketData: any[] = [];

  // PrimeNG dropdown options
  tradingPartnerOptions: any[] = [];

  // Selected values
  selectedBasketCode: any;
  selectedBasketCodeDesc = '';
  selectedSicCode: any;
  selectedFdiiCode: any;
  applicableYearKey: any;
  selectedLineNo: any;
  selectedBeatCode: any;
  selectedBeatCodeDesc = '';
  selectedBeatTypeCode: any;
  selectedBeatWithhold: any;
  selectedRelatedCode: any;
  selectedRelatedCodeDesc = '';
  selectedTradingPartnerCode: any;
  selectedTradingPartnerLEID: any;
  selectedCountryCode: any;
  selectedHtkoCode: any;
  selectedFsiCode: any;
  selectedSourceTypeCode: any;
  selectedProjectTaggingCode: any;
  selectedNotes: any;
  selectedMethodCode: any;
  selectedMethodTempCode: any;
  selectedBaseFdiiCodes: any;
  selectedBaseFdiiCodesCopy: any;
  selectedBaseBasketCode: any;
  selectedBaseBasketCodeCopy: any;
  selectedBaseTypeCode: any[] = [];
  selectedBaseTypeCodeTemp: any[] = [];
  selectedBaseLevelCode: any;
  selectedBaseEntityLevelCode: any;
  selectedBaseLevelCodeDESC: any;

  // Flags
  displaySingleSelectBase = '';
  gIncomeMethodFlag = '';
  disableCountry = '';
  disableFSE: string | undefined;
  disableBaseLevels = '';
  basketCodeDisable: any;
  selectedGieName = '';
  transCatgIsChangedFlag = 'N';
  transCatgMapDesc = '';
  showWarning = 'N';
  isMethodChangedManually = false;
  isMethodChangedManuallyEdit = false;
  AllocateMethodTransCatg = false;
  manualTransCategory = false;
  flagForNewUpdate = -1;
  editCount: number | null = 0;
  tranCatgCount = 0;
  methodChangeCount = 0;
  editCountCheckForActualData = 0;
  isResetClicked = false;
  resetOption = false;
  transCatgChangedFlag = false;
  methodChangedFlag = false;

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private jsonObjectFactory: JsonObjectFactoryService,
    private ftcAttributeEditService: FtcAttributeEditService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalParams = header.globalParams || {};
    this.userSettings = header.userSettingsData || {};
    this.filterParams = normalizeFilterParams(activeScreen);

    const g = gridPayloadFromActiveScreen(activeScreen);
    this.gridDataMultipleSelect = g != null && typeof g === 'object' ? g : {};
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG?.base_url) return;
    if (!this.gridDataMultipleSelect || Object.keys(this.gridDataMultipleSelect).length === 0) return;
    this.isInitialized = true;

    this.logged_in_user = this.userSettings?.user?.sso_id || this.userSettings?.sso_id || '';
    this.curentyear = this.filterParams.tax_year;
    this.scenario = this.filterParams.scenario;
    this.jcd_key = this.globalParams.jcd_key;

    if (this.gridDataMultipleSelect.colData && this.gridDataMultipleSelect.rowData) {
      this.selectedAttributeRow = [];
      this.selectedAttributeRow.push(this.gridDataMultipleSelect.rowData);
      this.rowData = this.gridDataMultipleSelect.rowData;
      this.editCount = 0;
      this.methodChangeCount = 0;
    }

    this.checkLockStatus();
    this.getCodeMastData();
  }

  /* ─── Lock Check (n10cpv) ─── */

  private checkLockStatus(): void {
    const lockparams = {
      action_code: 'n10cpv',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', lockparams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        const lockData = data.jsonObject;
        if (lockData?.[0]?.LOCK_STATUS === 'Y') {
          this.cancel();
          this.gtwSnackbar.openSnackBar('Tax Return has already been filed for tax year ' + this.curentyear + '.', 'gtw-snackbar--red', true, 4);
          return;
        }
        if (lockData?.[0]?.SCENARIO_DESC === 'EXAM') {
          this.QARScenario = 'Y';
        }
      }
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Code Mast Data (31hizx) ─── */

  getCodeMastData(): void {
    const ccKey = this.selectedAttributeRow[0]?.COMBINATION_KEY;
    if (!ccKey) return;
    const params = {
      action_code: '31hizx',
      cc_key: ccKey,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      const jsonObj = data?.jsonObject || [];
      this.codeMastDataTempData = jsonObj;
      this.basketCodeData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      this.basketCodeAllocateData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE_ALLOCATE'], p.CODE_GROUP));
      _.remove(this.basketCodeAllocateData, { CODE_DESCRIPTION: 'Default' });
      this.fdiiCodeData = _.filter(jsonObj, (p: any) => _.includes(['FDII_CODE'], p.CODE_GROUP));
      this.sicCodeData = _.filter(jsonObj, (p: any) => _.includes(['SIC_CODE_PER_ME'], p.CODE_GROUP));
      if (this.sicCodeData.length <= 1) {
        this.sicCodeData = _.filter(jsonObj, (p: any) => _.includes(['SIC_CODE'], p.CODE_GROUP));
      }
      this.taxYearData = _.filter(jsonObj, (p: any) => _.includes(['TAX_YEAR'], p.CODE_GROUP));
      this.sourceTypeCodeData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_TYPE_CODE'], p.CODE_GROUP));
      this.projectTagCodeData = _.filter(jsonObj, (p: any) => _.includes(['PROJECT_TAG_CODE'], p.CODE_GROUP));
      this.yesNoData = _.filter(jsonObj, (p: any) => _.includes(['YES_NO'], p.CODE_GROUP));
      this.beatTypeData = _.filter(jsonObj, (p: any) => _.includes(['BEAT_TYPE_CODE'], p.CODE_GROUP));
      this.relatedCodeData = _.filter(jsonObj, (p: any) => _.includes(['RELATED_CODE'], p.CODE_GROUP));
      this.countryCodeData = _.filter(jsonObj, (p: any) => _.includes(['COUNTRY_CODE'], p.CODE_GROUP));
      this.htkoData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      this.fsiData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      this.baseFDIIData = _.filter(jsonObj, (p: any) => _.includes(['FDII_CODE'], p.CODE_GROUP));
      this.baseBasketData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      _.remove(this.baseBasketData, { CODE_DESCRIPTION: 'Default' });
      this.syncDropdownList('baseFDII', this.baseFDIIData);
      this.syncDropdownList('baseBasket', this.baseBasketData);
      this.baseLevelData = _.filter(jsonObj, (p: any) => _.includes(['BASE_LEVEL_CODE'], p.CODE_GROUP));
      this.baseEntityData = _.filter(jsonObj, (p: any) => _.includes(['BASE_ENTITY_CODE'], p.CODE_GROUP));
      this.baseBasketTypeData = _.filter(jsonObj, (p: any) => _.includes(['BASE_BASKET_CODE'], p.CODE_GROUP));
      this.baseTypeCodeData = _.filter(jsonObj, (p: any) => _.includes(['BASE_TYPE_CODE'], p.CODE_GROUP));
      this.basefdiiSingleMultiData = _.filter(jsonObj, (p: any) => _.includes(['BASE_FDII_CODE'], p.CODE_GROUP));
      this.lineNoCodeData = _.filter(jsonObj, (p: any) => _.includes(['LINE_NO_CODE'], p.CODE_GROUP));

      this.tillCurrentTaxYear(Number(this.curentyear), 0, 11);
      this.getAttribNamebyGieName();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Attribute Display Names (6qd7am) ─── */

  getAttribNamebyGieName(): void {
    const gieName = this.selectedAttributeRow[0]?.GROSS_INC_EXP;
    if (!gieName) return;
    const params = { action_code: '6qd7am', gie_name: gieName };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.getAttribToDisplay = data?.jsonObject || [];
      this.newArray = this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      this.getTransactionCategoriesData();
      this.getAttribMast();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Transaction Categories for Edit (1sdudl) ─── */

  getTransactionCategoriesData(): void {
    const row = this.selectedAttributeRow[0];
    if (!row) return;
    const params = {
      action_code: '1sdudl',
      cc_key: row.COMBINATION_KEY,
      gie_name: row.GROSS_INC_EXP,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.baseTypeData = data?.jsonObject || [];
      this.transCategoryData = data?.jsonObject || [];
      this.syncDropdownList('baseType', this.baseTypeData);

      const exists = _.find(this.transCategoryData, ['CODE_DESCRIPTION', row.TRANS_CATG_NAME]);
      if (exists) {
        this.selectedTransCat = exists.CODE_KEY;
      }
      this.updateCountryField();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Attribute Master (2nk5nz) ─── */

  getAttribMast(): void {
    const params = { action_code: '2nk5nz' };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.attribMastData = data?.jsonObject || [];
      this.getTradingPartnerData();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Trading Partner Data (ayqh3u) ─── */

  getTradingPartnerData(): void {
    const params = {
      action_code: 'ayqh3u',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.tradingPartnerCodeData = data?.jsonObject || [];
      this.beatYesforeignTradingPartnerData = _.filter(this.tradingPartnerCodeData, (p: any) =>
        _.includes(['RELATED_FGN_BEAT_YES'], p.CODE_GROUP)
      );
      this.beatNoforeignTradingPartnerData = _.filter(this.tradingPartnerCodeData, (p: any) =>
        _.includes(['RELATED_FGN_BEAT_NO'], p.CODE_GROUP)
      );
      this.domesticTradingPartnerData = _.filter(this.tradingPartnerCodeData, (p: any) =>
        _.includes(['RELATED_DOMESTIC'], p.CODE_GROUP)
      );
      this.rebuildTradingPartnerOptions();
      this.getMethod();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Method codes (lwtsx1) ─── */

  getMethod(): void {
    const gieKey = this.selectedAttributeRow[0]?.GIE_KEY;
    if (!gieKey) return;
    const params = {
      action_code: 'lwtsx1',
      gie_key: gieKey,
      p_scenario: this.scenario,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.methodCodeData = data?.jsonObject || [];
      this.getAllTransCatgExceptExp();
      this.getDefaultsPopulateData();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: All Trans Categories except Exp (9aszao) ─── */

  getAllTransCatgExceptExp(): void {
    const params = {
      action_code: '9aszao',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.allTransCategoryData = data?.jsonObject || [];
      this.allGPTransCategoryData = _.filter(this.allTransCategoryData, (p: any) =>
        _.includes(['GPROFIT'], p.GIE_NAME)
      );
      this.getFSECompDefData();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Defaults Populate Data (4tivvr) ─── */

  getDefaultsPopulateData(): void {
    const row = this.selectedAttributeRow[0];
    if (!row) return;
    const params = {
      action_code: '4tivvr',
      gie_key: row.GIE_KEY,
      cc_key: row.COMBINATION_KEY,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.allDefaultData = data?.jsonObject || [];
      this.applyDefaultsForEdit();
      this.cdr.detectChanges();
    });
  }

  private applyDefaultsForEdit(): void {
    if (this.selectedSicCode == undefined || this.selectedSicCode === '') {
      const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'SIC_CODES']);
      if (dv) {
        const ex = _.find(this.sicCodeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
        if (ex) this.selectedSicCode = ex.CODE_KEY;
      }
    }
    if (this.selectedBasketCode == undefined || this.selectedBasketCode === '') {
      const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BASKET']);
      if (dv) {
        const ex = _.find(this.basketCodeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
        if (ex) this.selectedBasketCode = ex.CODE_KEY;
      }
    }
    if (this.selectedFdiiCode == undefined || this.selectedFdiiCode === '') {
      const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'FDII']);
      if (dv) {
        const ex = _.find(this.fdiiCodeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
        if (ex) this.selectedFdiiCode = ex.CODE_KEY;
      }
    }
    if (this.selectedMethodCode == undefined || this.selectedMethodCode === '') {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'METHOD']);
      if (exists) {
        const mc = _.find(this.methodCodeData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (mc) this.selectedMethodCode = mc;
      }
    }
    if (this.selectedMethodTempCode != undefined) {
      const exists = _.find(this.methodCodeData, ['CODE_KEY', this.selectedMethodTempCode]);
      if (exists) this.selectedMethodCode = exists;
    }
    if (this.selectedBaseLevelCode == undefined) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BASE_LEVEL']);
      if (exists) {
        const bl = _.find(this.baseLevelData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (bl) this.selectedBaseLevelCode = bl.CODE_KEY;
      }
    }
    if (this.selectedBaseEntityLevelCode == undefined) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BASE_ENTITY_LEVEL']);
      if (exists) {
        const be = _.find(this.baseEntityData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (be) this.selectedBaseEntityLevelCode = be.CODE_KEY;
      }
    }
    if (this.selectedBaseBasketCode == undefined || this.selectedBaseBasketCode === '') {
      const defaultBB = _.filter(this.allDefaultData, (p: any) => _.includes(['BASE_BASKET'], p.ATTRIB_NAME));
      if (defaultBB?.length > 0 && this.baseBasketData?.length > 0) {
        const temp: any[] = [];
        defaultBB.forEach((d: any) => {
          this.baseBasketData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) temp.push(m);
          });
        });
        this.selectedBaseBasketCode = this.uniqueData(temp, 'CODE_KEY');
        this.selectedBaseBasketCodeCopy = _.cloneDeep(this.selectedBaseBasketCode);
      }
    }
    if (this.selectedBaseFdiiCodes == undefined || this.selectedBaseFdiiCodes === '') {
      const defaultFdii = _.filter(this.allDefaultData, (p: any) => _.includes(['BASE_FDII'], p.ATTRIB_NAME));
      if (defaultFdii?.length > 0 && this.baseFDIIData?.length > 0) {
        const temp: any[] = [];
        defaultFdii.forEach((d: any) => {
          this.baseFDIIData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) temp.push(m);
          });
        });
        this.selectedBaseFdiiCodes = this.uniqueData(temp, 'CODE_KEY');
        this.selectedBaseFdiiCodesCopy = _.cloneDeep(this.selectedBaseFdiiCodes);
      }
    }
    if (this.selectedBeatCode == undefined) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BEAT']);
      if (exists) {
        const yn = _.find(this.yesNoData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (yn) {
          this.selectedBeatCode = yn.CODE_KEY;
          this.selectedBeatCodeDesc = yn.CODE_DESCRIPTION;
        }
      }
    }
    if (this.selectedSourceTypeCode == undefined) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'SOURCE_TYPE']);
      if (exists) {
        const st = _.find(this.sourceTypeCodeData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (st) this.selectedSourceTypeCode = st.CODE_KEY;
      }
    }
    if (this.selectedRelatedCode == undefined) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'RELATED_UNRELATED']);
      if (exists) {
        const rc = _.find(this.relatedCodeData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (rc) {
          this.selectedRelatedCode = rc.CODE_KEY;
          this.selectedRelatedCodeDesc = rc.CODE_DESCRIPTION;
        }
      }
    }
    if (this.selectedCountryCode == undefined || this.selectedCountryCode === '') {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'COUNTRY']);
      if (exists) {
        const cc = _.find(this.countryCodeData, ['CODE_DESC', exists.CODE_DESCRIPTION]);
        if (cc) this.selectedCountryCode = cc.CODE_KEY;
      }
    }
    if (this.selectedLineNo == undefined || this.selectedLineNo === '') {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'LINE_NO']);
      if (exists) {
        const ln = _.find(this.lineNoCodeData, ['CODE_DESC', exists.CODE_DESCRIPTION]);
        if (ln) this.selectedLineNo = ln.CODE_KEY;
      }
    }
  }

  /* ─── API: FSE Component Default Data (8kj84y) ─── */

  getFSECompDefData(): void {
    const ccKey = this.selectedAttributeRow[0]?.COMBINATION_KEY;
    if (!ccKey) return;
    const params = {
      action_code: '8kj84y',
      cc_key: ccKey,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.fseCompDefaultData = data?.jsonObject || [];
      this.prePopulateData();
      this.validations();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Base Data for Trans Category (py0jb5) ─── */

  getBaseData(): void {
    const row = this.selectedAttributeRow[0];
    if (row && !this.manualTransCategory) {
      const exists = _.find(this.transCategoryData, ['CODE_DESCRIPTION', row.TRANS_CATG_NAME]);
      if (exists) this.selectedTransCat = exists.CODE_KEY;
    }
    const params = {
      action_code: 'py0jb5',
      trans_catg_name: this.selectedTransCat,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage !== 'null' && data.errorMessage.length > 0) {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      const jsonObj = data?.jsonObject || [];
      this.AllocateMethodTransCatg = false;

      // Base FDII from trans catg mapping
      const baseFDIITempData = _.filter(jsonObj, (p: any) => _.includes(['BASE_FDII'], p.CODE_GROUP));
      const selectedBaseFdiiCodesTemp: any[] = [];
      if (jsonObj.length > 0 && baseFDIITempData.length > 0) {
        jsonObj.forEach((d: any) => {
          baseFDIITempData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) selectedBaseFdiiCodesTemp.push(m);
          });
        });
        this.selectedBaseFdiiCodes = this.uniqueData(selectedBaseFdiiCodesTemp, 'CODE_KEY');
        this.selectedBaseFdiiCodesCopy = _.cloneDeep(this.selectedBaseFdiiCodes);
      } else {
        this.selectedBaseFdiiCodes = _.cloneDeep(this.baseFDIIData);
        this.selectedBaseFdiiCodesCopy = _.cloneDeep(this.baseFDIIData);
      }

      // Base Basket from trans catg mapping
      const baseBasketTempData = _.filter(jsonObj, (p: any) => _.includes(['BASE_BASKET'], p.CODE_GROUP));
      const selectedBaseBasketCodeTemp: any[] = [];
      if (jsonObj.length > 0 && baseBasketTempData.length > 0) {
        jsonObj.forEach((d: any) => {
          baseBasketTempData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) selectedBaseBasketCodeTemp.push(m);
          });
        });
        this.selectedBaseBasketCode = this.uniqueData(selectedBaseBasketCodeTemp, 'CODE_KEY');
        this.selectedBaseBasketCodeCopy = _.cloneDeep(this.selectedBaseBasketCode);
      } else {
        this.selectedBaseBasketCode = _.cloneDeep(this.baseBasketData);
        this.selectedBaseBasketCodeCopy = _.cloneDeep(this.baseBasketData);
      }

      // Base Type from trans catg mapping
      const baseTypeTempData = _.filter(jsonObj, (p: any) => _.includes(['BASE_TYPE'], p.CODE_GROUP));
      const selectedBaseTypeCodeTemp: any[] = [];
      if (jsonObj.length > 0 && baseTypeTempData.length > 0) {
        this.selectedBaseTypeCode = [];
        jsonObj.forEach((d: any) => {
          baseTypeTempData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) selectedBaseTypeCodeTemp.push(m);
          });
        });
        this.selectedBaseTypeCode = this.uniqueData(selectedBaseTypeCodeTemp, 'CODE_KEY');
        this.selectedBaseTypeCodeTemp = this.uniqueData(selectedBaseTypeCodeTemp, 'CODE_KEY');
        this.transCatgChangedFlag = true;
      } else {
        this.selectedBaseTypeCode = _.cloneDeep(this.baseTypeData);
        this.selectedBaseTypeCodeTemp = _.cloneDeep(this.baseTypeData);
      }

      // Base Level / Entity / Method from trans catg mapping
      const baseLevelArr = _.filter(jsonObj, (p: any) => _.includes(['BASE_LEVEL_CODE'], p.CODE_GROUP));
      if (baseLevelArr[0]) this.selectedBaseLevelCode = baseLevelArr[0].CODE_KEY;

      const baseEntityArr = _.filter(jsonObj, (p: any) => _.includes(['BASE_ENTITY_CODE'], p.CODE_GROUP));
      if (baseEntityArr[0]) this.selectedBaseEntityLevelCode = baseEntityArr[0].CODE_KEY;

      const methodArr = _.filter(jsonObj, (p: any) => _.includes(['METHOD_CODE'], p.CODE_GROUP));
      if (methodArr[0]) {
        this.selectedMethodTempCode = methodArr[0].CODE_KEY;
        if (methodArr[0].CODE_DESCRIPTION === 'Allocate') {
          this.AllocateMethodTransCatg = true;
          if (Array.isArray(this.selectedBaseBasketCode) && this.selectedBaseBasketCode.length > 0) {
            this.selectedBaseBasketCode = this.selectedBaseBasketCode[0].CODE_KEY;
          }
          if (Array.isArray(this.selectedBaseFdiiCodes) && this.selectedBaseFdiiCodes.length > 0) {
            this.selectedBaseFdiiCodes = this.selectedBaseFdiiCodes[0].CODE_KEY;
          }
        }
      }

      if (this.methodCodeData) {
        const exists = _.find(this.methodCodeData, ['CODE_KEY', this.selectedMethodTempCode]);
        if (exists) this.selectedMethodCode = exists;
      }

      this.flagForNewUpdate++;
      this.baseFDIIData = _.cloneDeep(this.baseFDIIData);
      this.baseFDIIDataCopy = _.cloneDeep(this.baseFDIIData);
      this.baseBasketData = _.cloneDeep(this.baseBasketData);
      this.baseBasketDataCopy = _.cloneDeep(this.baseBasketData);
      this.baseTypeData = _.cloneDeep(this.baseTypeData);
      this.baseTypeDataCopy = _.cloneDeep(this.baseTypeData);
      this.syncDropdownList('baseFDII', this.baseFDIIData);
      this.syncDropdownList('baseBasket', this.baseBasketData);
      this.syncDropdownList('baseType', this.baseTypeData);

      this.loadingData = false;
      this.cdr.detectChanges();
    });
  }

  /* ─── Pre-populate fields from row data (Edit mode) ─── */

  prePopulateData(): void {
    const row = this.selectedAttributeRow[0];
    if (!row) return;

    let exists: any;

    exists = _.find(this.basketCodeData, ['CODE_DESCRIPTION', row.BASKET_0]);
    if (exists) {
      this.selectedBasketCode = exists.CODE_KEY;
      this.selectedBasketCodeDesc = exists.CODE_DESCRIPTION;
    }

    exists = _.find(this.sicCodeData, ['CODE_DESCRIPTION', row.SIC_CODES_0 ? row.SIC_CODES_0.split('[')[0] : null]);
    if (exists) this.selectedSicCode = exists.CODE_KEY;

    exists = _.find(this.fdiiCodeData, ['CODE_DESCRIPTION', row.FDII_0]);
    if (exists) this.selectedFdiiCode = exists.CODE_KEY;

    exists = _.find(this.yesNoData, ['CODE_DESCRIPTION', row.BEAT_0]);
    if (exists) {
      this.selectedBeatCode = exists.CODE_KEY;
      this.selectedBeatCodeDesc = exists.CODE_DESCRIPTION;
    }

    exists = _.find(this.beatTypeData, ['CODE_DESCRIPTION', row.BEAT_TYPE_0]);
    if (exists) this.selectedBeatTypeCode = exists.CODE_KEY;

    exists = _.find(this.relatedCodeData, ['CODE_DESCRIPTION', row.RELATED_UNRELATED_0]);
    if (exists) {
      this.selectedRelatedCode = exists.CODE_KEY;
      this.selectedRelatedCodeDesc = exists.CODE_DESCRIPTION;
    }

    if (row.RELATED_UNRELATED_0 === 'Related Foreign' || row.RELATED_UNRELATED_0 === 'Related Domestic') {
      this.selectedTradingPartnerLEID = row.ACTUAL_TP_KEY_0;
      this.selectedTradingPartnerCode = row.ACTUAL_TP_KEY_LENAME_0;
      this.disableCountry = 'Yes';
    }
    this.rebuildTradingPartnerOptions();

    exists = _.find(this.countryCodeData, ['CODE_DESCRIPTION', row.COUNTRY_0 ? row.COUNTRY_0.split('[')[0] : null]);
    if (exists) this.selectedCountryCode = exists.CODE_KEY;

    exists = _.find(this.htkoData, ['CODE_DESCRIPTION', row.HTKO_0]);
    if (exists) this.selectedHtkoCode = exists.CODE_KEY;

    exists = _.find(this.fsiData, ['CODE_DESCRIPTION', row.FSE_0]);
    if (exists) this.selectedFsiCode = exists.CODE_KEY;

    exists = _.find(this.sourceTypeCodeData, ['CODE_DESCRIPTION', row.SOURCE_TYPE_0]);
    if (exists) this.selectedSourceTypeCode = exists.CODE_KEY;

    exists = _.find(this.projectTagCodeData, ['CODE_DESCRIPTION', row.PROJECT_TAGGING_0]);
    if (exists) this.selectedProjectTaggingCode = exists.CODE_KEY;

    this.selectedNotes = row.NOTES_0;
    this.selectedBeatWithhold = row.BEAT_WITHHOLD_0;

    exists = _.find(this.methodCodeData, ['CODE_DESCRIPTION', row.METHOD_0]);
    if (exists) {
      this.selectedMethodCode = exists;
      const gieName = row.GROSS_INC_EXP;
      if (gieName === 'RESEARCH' || gieName === 'INTEXP' || gieName === 'EXPAA' || gieName === 'INVESTMENTS') {
        this.changeMethod(true);
      }
    }

    // Base FDII pre-select
    exists = _.find(this.basefdiiSingleMultiData, ['CODE_DESCRIPTION', row.BASE_FDII_0]);
    if (exists) this.getBaseFDIISelected();

    // Base Basket pre-select
    exists = _.find(this.baseBasketTypeData, ['CODE_DESCRIPTION', row.BASE_BASKET_0]);
    if (exists) this.getBaseBasketSelected();

    // Base Type pre-select
    exists = _.find(this.baseBasketTypeData, ['CODE_DESCRIPTION', row.BASE_TYPE_0]);
    if (exists) this.getBaseTypeSelected();

    exists = _.find(this.baseLevelData, ['CODE_DESCRIPTION', row.BASE_LEVEL_0]);
    if (exists) this.selectedBaseLevelCode = exists.CODE_KEY;

    exists = _.find(this.baseEntityData, ['CODE_DESCRIPTION', row.BASE_ENTITY_LEVEL_0]);
    if (exists) this.selectedBaseEntityLevelCode = exists.CODE_KEY;

    exists = _.find(this.lineNoCodeData, ['CODE_DESCRIPTION', row.LINE_NO_0]);
    if (exists) this.selectedLineNo = exists.CODE_KEY;

    const exists1 = _.find(this.basketCodeData, ['CODE_DESCRIPTION', 'Passive']);
    if (exists1) this.basketCodeDisable = exists1.CODE_KEY;

    if (this.fseCompDefaultData?.length === 0 && this.basketCodeDisable == this.selectedBasketCode) {
      this.disableFSE = 'true';
    } else if (this.fseCompDefaultData?.length > 0 && this.basketCodeDisable == this.selectedBasketCode) {
      this.disableFSE = 'false';
    } else {
      this.disableFSE = undefined;
    }
  }

  /* ─── API: Base FDII Selected (8blhrv) ─── */

  getBaseFDIISelected(): void {
    const row = this.selectedAttributeRow[0];
    const params = {
      action_code: '8blhrv',
      tag_key: row.TAG_KEY,
      p_scenario: this.scenario,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      if (this.displaySingleSelectBase === 'true') {
        let defaultFDIICodeNew = '';
        const fromAllDefault = _.find(this.allDefaultData, ['ATTRIB_NAME', 'FDII']);
        if (fromAllDefault) {
          const ex = _.find(this.baseFDIIData, ['CODE_DESCRIPTION', fromAllDefault.CODE_DESCRIPTION]);
          if (ex) defaultFDIICodeNew = ex.CODE_KEY;
        }
        this.selectedBaseFdiiCodes = data.jsonObject?.[0] ? data.jsonObject[0].CODE_KEY : defaultFDIICodeNew;
      } else {
        const selectedBaseFdiiCodesTemp: any[] = [];
        if (data.jsonObject?.length > 0 && this.baseFDIIData.length > 0) {
          data.jsonObject.forEach((d: any) => {
            this.baseFDIIData.forEach((m: any) => {
              if (m.CODE_KEY === d.CODE_KEY) selectedBaseFdiiCodesTemp.push(m);
            });
          });
          this.selectedBaseFdiiCodes = this.uniqueData(selectedBaseFdiiCodesTemp, 'CODE_KEY');
          this.selectedBaseFdiiCodesCopy = _.cloneDeep(this.selectedBaseFdiiCodes);
        }
      }
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Base Basket Selected (pbh5uq) ─── */

  getBaseBasketSelected(): void {
    const row = this.selectedAttributeRow[0];
    const params = {
      action_code: 'pbh5uq',
      tag_key: row.TAG_KEY,
      p_scenario: this.scenario,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      if (this.displaySingleSelectBase === 'true') {
        let defaultBBCode = '';
        const fromAllDefault = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BASKET']);
        if (fromAllDefault) {
          const ex = _.find(this.baseBasketData, ['CODE_DESCRIPTION', fromAllDefault.CODE_DESCRIPTION]);
          if (ex) defaultBBCode = ex.CODE_KEY;
        }
        this.selectedBaseBasketCode = data.jsonObject?.[0] ? data.jsonObject[0].CODE_KEY : defaultBBCode;
      } else {
        const selectedBaseBasketCodeTemp: any[] = [];
        if (data.jsonObject?.length > 0 && this.baseBasketData.length > 0) {
          data.jsonObject.forEach((d: any) => {
            this.baseBasketData.forEach((m: any) => {
              if (m.CODE_KEY === d.CODE_KEY) selectedBaseBasketCodeTemp.push(m);
            });
          });
          this.selectedBaseBasketCode = this.uniqueData(selectedBaseBasketCodeTemp, 'CODE_KEY');
          this.selectedBaseBasketCodeCopy = _.cloneDeep(this.selectedBaseBasketCode);
        }
      }
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Base Type Selected (8ca0bw) ─── */

  getBaseTypeSelected(): void {
    const row = this.selectedAttributeRow[0];
    const params = {
      action_code: '8ca0bw',
      tag_key: row.TAG_KEY,
      p_scenario: this.scenario,
      p_tax_year: this.curentyear,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      const selectedBaseTypeCodeTemp: any[] = [];
      if (data.jsonObject?.length > 0 && this.baseTypeData.length > 0) {
        this.selectedBaseTypeCode = [];
        data.jsonObject.forEach((d: any) => {
          this.baseTypeData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) selectedBaseTypeCodeTemp.push(m);
          });
        });
        this.selectedBaseTypeCode = this.uniqueData(selectedBaseTypeCodeTemp, 'CODE_KEY');
        this.selectedBaseTypeCodeTemp = this.uniqueData(selectedBaseTypeCodeTemp, 'CODE_KEY');
      }
      this.cdr.detectChanges();
    });
  }

  /* ─── Validations ─── */

  private validations(): void {
    _.remove(this.htkoData, { CODE_DESCRIPTION: 'Passive' });
    _.remove(this.fsiData, { CODE_DESCRIPTION: 'Passive' });

    const gieName = this.selectedAttributeRow[0]?.GROSS_INC_EXP || '';
    const gieType = this.selectedAttributeRow[0]?.GIE_TYPE || '';
    if (gieName !== 'GPROFIT') {
      _.remove(this.sourceTypeCodeData, { CODE_DESCRIPTION: 'Summary' });
    }
    if (gieType === 'INC' || gieType === 'INVESTMENTS') {
      _.remove(this.sourceTypeCodeData, { CODE_DESCRIPTION: 'Percentage' });
    }
    this.loadingData = false;
  }

  /* ─── Tax Year filter ─── */

  private tillCurrentTaxYear(curentYr: number, fromPriorYr: number, tillPriorYr: number): void {
    this.filteredTaxYearData = [];
    for (const ty of this.taxYearData) {
      if (ty.CODE_GROUP === 'TAX_YEAR' &&
          ty.CODE_DESC <= (curentYr - fromPriorYr) &&
          ty.CODE_DESC >= (curentYr - tillPriorYr)) {
        this.filteredTaxYearData.push(ty);
      }
    }
    const row = this.selectedAttributeRow[0];
    if (row?.APPLICABLE_YEAR_0 != undefined) {
      this.applicableYearKey = this.getTaxYearKey(row.APPLICABLE_YEAR_0);
    } else {
      this.applicableYearKey = this.getTaxYearKey(this.filterParams.tax_year);
    }
  }

  private getTaxYearKey(taxYearDesc: string): any {
    for (const ty of this.taxYearData) {
      if (ty.CODE_DESC == taxYearDesc) {
        return ty.CODE_KEY;
      }
    }
    return undefined;
  }

  /* ─── Change Handlers ─── */

  updateCountryField(manual?: boolean): void {
    this.manualTransCategory = manual ? true : false;
    this.disableBaseLevels = '';
    this.isMethodChangedManually = false;
    this.isMethodChangedManuallyEdit = false;

    const exists = _.find(this.transCategoryData, ['CODE_KEY', this.selectedTransCat]);
    if (exists) {
      this.transCatgIsChangedFlag = exists.IS_CHANGED;
      this.transCatgMapDesc = exists.MAP_DESC;
      this.showWarning = exists.SHOW_WARINING;
    }

    if (this.showWarning === 'Y') {
      if (!confirm('Selected Transaction Category exists for another tag for same entity?')) {
        this.cancel();
        return;
      }
      if (this.transCatgIsChangedFlag === 'Y') {
        this.showTransCatgWarning();
      }
    }

    if (this.transCatgIsChangedFlag === 'Y' && this.showWarning === 'N') {
      this.showTransCatgWarning();
    }

    if (this.transCatgMapDesc === 'Y' && this.transCatgIsChangedFlag === 'N') {
      this.getBaseData();
    } else if (this.rowData && this.transCatgMapDesc === 'Y' && this.transCatgIsChangedFlag === 'Y') {
      const exists2 = _.find(this.methodCodeData, ['CODE_DESCRIPTION', 'Best Method - FDII']);
      if (exists2) this.selectedMethodCode = exists2;
      this.selectedBaseFdiiCodesCopy = _.cloneDeep(this.baseFDIIDataCopy);
      this.selectedBaseBasketCodeCopy = _.cloneDeep(this.baseBasketDataCopy);
      this.selectedBaseTypeCodeTemp = _.cloneDeep(this.baseTypeDataCopy);
      this.flagForNewUpdate++;
    }

    if (this.transCatgIsChangedFlag === 'N') {
      this.removeSetAttributes();
    }

    this.tranCatgCount++;
    this.cdr.detectChanges();
  }

  private showTransCatgWarning(): void {
    if (confirm('Trans category definition is changed and amount will be synced by nightly process. Do you want to proceed?')) {
      this.removeSetAttributes();
      this.getBaseData();
    } else {
      this.cancel();
    }
  }

  removeSetAttributes(): void {
    const servicesExists = _.find(this.transCategoryData, ['CODE_DESCRIPTION', 'Services']);
    const transCatgKeyService = servicesExists ? servicesExists.CODE_KEY : undefined;
    const prorateExists = _.find(this.transCategoryData, ['CODE_DESCRIPTION', 'Prorate Variance']);
    const transCatgKeyProrate = prorateExists ? prorateExists.CODE_KEY : undefined;

    this.selectedGieName = this.selectedAttributeRow[0]?.GROSS_INC_EXP || '';

    if (!this.getAttribToDisplay || this.getAttribToDisplay.length === 0) {
      this.getAttribNamebyGieName();
      return;
    }

    if (this.selectedGieName === 'GPROFIT' && transCatgKeyProrate == this.selectedTransCat) {
      const newList = _.cloneDeep(this.getAttribToDisplay);
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'SIC Code' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Basket' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'FDII' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'HTKO' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'FSE' });
      this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      this.disableBaseLevels = 'Yes';
    } else if (this.selectedGieName === 'GPROFIT' && transCatgKeyService == this.selectedTransCat) {
      const newList = _.cloneDeep(this.getAttribToDisplay);
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Basket' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base FDII' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Type' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Entity Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Method' });
      this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
    } else if (this.selectedGieName === 'GPROFIT') {
      const newList = _.cloneDeep(this.getAttribToDisplay);
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Basket' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base FDII' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Type' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Entity Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Method' });
      this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
    } else {
      if (this.getAttribToDisplay) {
        if (this.selectedMethodCode && this.selectedMethodCode.CODE_DESCRIPTION !== 'Allocate'
            && this.selectedMethodCode.CODE_DESCRIPTION !== 'Interest Expense') {
          this.newArray = this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME);
        }
      }
    }
    this.cdr.detectChanges();
  }

  changeBasketCode(): void {
    const exists1 = _.find(this.basketCodeData, ['CODE_DESCRIPTION', 'Passive']);
    if (exists1) this.basketCodeDisable = exists1.CODE_KEY;

    if (this.fseCompDefaultData.length === 0 && this.basketCodeDisable == this.selectedBasketCode) {
      this.disableFSE = 'true';
    } else if (this.fseCompDefaultData.length > 0 && this.basketCodeDisable == this.selectedBasketCode) {
      this.disableFSE = 'false';
    } else {
      this.disableFSE = undefined;
    }

    const exists = _.find(this.basketCodeData, ['CODE_KEY', this.selectedBasketCode]);
    if (exists) this.selectedBasketCodeDesc = exists.CODE_DESCRIPTION;

    _.remove(this.htkoData, { CODE_DESCRIPTION: 'Passive' });
    _.remove(this.fsiData, { CODE_DESCRIPTION: 'Passive' });
    this.selectedHtkoCode = undefined;
    this.selectedFsiCode = undefined;
    this.cdr.detectChanges();
  }

  changeBeatCode(): void {
    const exists = _.find(this.yesNoData, ['CODE_KEY', this.selectedBeatCode]);
    if (exists) {
      this.selectedBeatCodeDesc = exists.CODE_DESCRIPTION;
    } else {
      this.selectedBeatCodeDesc = '';
      this.selectedBeatTypeCode = '';
      this.selectedRelatedCode = '';
      this.selectedRelatedCodeDesc = '';
      this.selectedTradingPartnerCode = '';
      this.selectedCountryCode = '';
      this.selectedBeatWithhold = undefined;
    }

    if (this.selectedBeatCodeDesc === 'Yes') {
      const relFgn = _.find(this.relatedCodeData, ['CODE_DESCRIPTION', 'Related Foreign']);
      if (relFgn) {
        this.selectedRelatedCode = relFgn.CODE_KEY;
        this.selectedRelatedCodeDesc = 'Related Foreign';
      }
      this.disableCountry = 'Yes';
      this.selectedTradingPartnerCode = '';
      this.selectedCountryCode = '';

      if (this.selectedBeatTypeCode == undefined || this.selectedBeatTypeCode === '') {
        const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BEAT_TYPE']);
        if (dv) {
          const bt = _.find(this.beatTypeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
          if (bt) this.selectedBeatTypeCode = bt.CODE_KEY;
        }
      }
    } else if (this.selectedBeatCodeDesc === 'No') {
      this.selectedBeatTypeCode = '';
      this.selectedBeatWithhold = undefined;
      this.selectedTradingPartnerCode = '';
      this.selectedCountryCode = '';
    }
    this.rebuildTradingPartnerOptions();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  changeRelatedCode(): void {
    this.selectedCountryCode = '';
    const exists = _.find(this.relatedCodeData, ['CODE_KEY', this.selectedRelatedCode]);
    if (exists) this.selectedRelatedCodeDesc = exists.CODE_DESCRIPTION;

    if (this.selectedRelatedCodeDesc === 'Related Domestic') {
      this.selectedTradingPartnerCode = '';
      this.disableCountry = 'Yes';
    }
    if (this.selectedRelatedCodeDesc === 'Related Foreign') {
      this.selectedTradingPartnerCode = '';
      this.disableCountry = 'Yes';
    }
    if (this.selectedRelatedCodeDesc === 'UnRelated') {
      this.selectedTradingPartnerCode = '';
      this.disableCountry = '';
      if (this.selectedCountryCode == undefined || this.selectedCountryCode === '') {
        const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'COUNTRY']);
        if (dv) {
          const cc = _.find(this.countryCodeData, ['CODE_DESC', dv.CODE_DESCRIPTION]);
          if (cc) this.selectedCountryCode = cc.CODE_KEY;
        }
      }
    }
    if (this.selectedBeatCodeDesc == undefined) this.selectedBeatCodeDesc = '';
    this.rebuildTradingPartnerOptions();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  changeTradingPartner(): void {
    const exists = _.find(this.tradingPartnerCodeData, ['COMBINATION_KEY', this.selectedTradingPartnerCode]);
    if (exists) {
      this.selectedTradingPartnerLEID = exists.COMBINATION_KEY;
      const cExists = _.find(this.countryCodeData, ['CODE_SHORT_DESC', exists.LE_COUNTRY]);
      if (cExists) {
        this.selectedCountryCode = cExists.CODE_KEY;
      } else {
        this.selectedCountryCode = '';
      }
    }
    this.cdr.detectChanges();
  }

  changeInCreateMethodEdit(): void {
    this.isMethodChangedManuallyEdit = true;
    this.changeMethod(true);
  }

  changeMethod(type?: boolean): void {
    this.displaySingleSelectBase = '';
    this.gIncomeMethodFlag = '';
    this.selectedGieName = this.selectedAttributeRow[0]?.GROSS_INC_EXP || '';
    if (type) this.manualTransCategory = false;

    if (this.selectedGieName && (this.selectedGieName === 'INTEXP' || this.selectedGieName === 'RESEARCH')) {
      if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Allocate') {
        this.displaySingleSelectBase = 'true';
        const newList = _.cloneDeep(this.getAttribToDisplay);
        this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);

        if (!this.AllocateMethodTransCatg) {
          if (this.baseFDIIData?.length > 0) this.singleBaseFDIIData = _.cloneDeep(this.baseFDIIData);
          if (this.baseBasketData?.length > 0) this.singleBaseBasketData = _.cloneDeep(this.baseBasketData);

          const fdiiEx = _.find(this.baseFDIIData, ['CODE_DESC', 'US Derived DEI']);
          if (fdiiEx) this.selectedBaseFdiiCodes = fdiiEx.CODE_KEY;
          const bbEx = _.find(this.baseBasketData, ['CODE_DESC', 'U.S.']);
          if (bbEx) this.selectedBaseBasketCode = bbEx.CODE_KEY;
        }
      }
      if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Interest Expense' ||
          this.selectedMethodCode?.CODE_DESCRIPTION === 'Research Expense') {
        const newList = _.cloneDeep(this.getAttribToDisplay);
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base FDII' });
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Basket' });
        this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      }
    }

    if (this.selectedGieName && (this.selectedGieName === 'EXPAA' || this.selectedGieName === 'ASTEXP' || this.selectedGieName === 'INVESTMENTS')) {
      if (this.selectedMethodCode && this.selectedMethodCode.CODE_DESCRIPTION !== 'Allocate' && this.selectedMethodCode.CODE_DESCRIPTION !== 'Gross Income') {
        if (type) {
          if (this.allGPTransCategoryData.length === 0) {
            this.getAllTransCatgExceptExp();
          } else {
            this.baseTypeData = this.allGPTransCategoryData;
            this.syncDropdownList('baseType', this.baseTypeData);
            if (this.rowData?.BASE_TYPE_0 === 'MULTI') {
              this.selectedBaseTypeCode = this.selectedBaseTypeCodeTemp;
            }
          }
        }
        this.newArray = this.getAttribToDisplay ? this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME) : [];
      } else if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Allocate') {
        this.displaySingleSelectBase = 'true';
        if (!this.AllocateMethodTransCatg) {
          let fdiiEx = _.find(this.baseFDIIData, ['CODE_DESC', 'US Derived DEI']);
          if (!fdiiEx) fdiiEx = _.find(this.baseFDIIData, ['CODE_DESCRIPTION', 'US Derived DEI']);
          if (fdiiEx) this.selectedBaseFdiiCodes = fdiiEx.CODE_KEY;

          let bbEx = _.find(this.baseBasketData, ['CODE_DESC', 'U.S.']);
          if (!bbEx) bbEx = _.find(this.baseBasketData, ['CODE_DESCRIPTION', 'U.S.']);
          if (bbEx) this.selectedBaseBasketCode = parseInt(bbEx.CODE_KEY, 10);
        }
        const newList = _.cloneDeep(this.getAttribToDisplay);
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Level' });
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Type' });
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Entity Level' });
        this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      } else if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Gross Income') {
        this.gIncomeMethodFlag = 'true';
        if (type) {
          this.baseTypeData = this.allTransCategoryData;
          this.syncDropdownList('baseType', this.baseTypeData);
        }
        this.newArray = this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      }
    }

    if (type) {
      this.methodChangedFlag = !this.methodChangedFlag;
      this.methodChangeCount++;
      if (this.rowData) {
        if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Gross Income') {
          const tempGP = this.allTransCategoryData;
          if (this.rowData.BASE_TYPE_0 === 'ALL' || this.editCountCheckForActualData > 0) {
            this.selectedBaseTypeCodeTemp = tempGP;
            this.selectedBaseTypeCode = tempGP;
          }
        } else {
          const tempGP = this.allGPTransCategoryData;
          if (this.rowData.BASE_TYPE_0 === 'ALL' || this.editCountCheckForActualData > 0) {
            this.selectedBaseTypeCodeTemp = tempGP;
            this.selectedBaseTypeCode = tempGP;
          }
        }
      }
    }
    this.cdr.detectChanges();
  }

  changeSelectedBeatWithHold(): void {
    if (this.selectedBeatWithhold && (this.selectedBeatWithhold < 0 || this.selectedBeatWithhold > 100)) {
      this.gtwSnackbar.openSnackBar('Please select BEAT Withhold between 0 to 100 only', 'gtw-snackbar--red', true, 5);
      this.isError = true;
    } else {
      this.isError = false;
    }
  }

  editCountCheckForActual(): void {
    this.editCountCheckForActualData++;
  }

  /* ─── Compare function for mat-select ─── */

  compareItems(a: any, b: any): boolean {
    return a && b && a.CODE_KEY == b.CODE_KEY;
  }

  /* ─── Save ─── */

  save(): void {
    this.isSaveClicked = true;
    const row = this.selectedAttributeRow[0];
    const returnObj: any = {};

    returnObj.COMBINATION_KEY = row.COMBINATION_KEY;
    returnObj.TAG_KEY = row.TAG_KEY;
    returnObj.GIE_KEY = row.GIE_KEY;
    returnObj.OPERATION_TYPE = 'MU';
    returnObj.TRANS_CATG_KEY = this.selectedTransCat;

    // Trading Partner validation
    const unrelatedExists = _.find(this.relatedCodeData, ['CODE_DESCRIPTION', 'UnRelated']);
    const disableTP = unrelatedExists && this.selectedRelatedCode == unrelatedExists.CODE_KEY;

    if (this.newArray.indexOf('Trading Partner') > -1 && !disableTP) {
      if (!this.selectedTradingPartnerCode || this.selectedTradingPartnerCode === '') {
        this.gtwSnackbar.openSnackBar('Please select Trading Partner to proceed', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false;
        return;
      }
      const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'ACTUAL_TP_KEY']);
      if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = this.selectedTradingPartnerLEID;
    }

    if (this.newArray.indexOf('Country') > -1) {
      if (!this.selectedCountryCode || this.selectedCountryCode === '') {
        this.gtwSnackbar.openSnackBar('Please select Country to proceed', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false;
        return;
      }
      const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY']);
      if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = this.selectedCountryCode;
    }

    this.setAttribField(returnObj, 'Basket', 'BASKET', this.selectedBasketCode);
    this.setAttribField(returnObj, 'SIC Code', 'SIC_CODES', this.selectedSicCode);
    this.setAttribField(returnObj, 'FDII', 'FDII', this.selectedFdiiCode);

    const beatAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT']);
    if (beatAttrib) returnObj[beatAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatCode;

    if (this.selectedBeatTypeCode && this.selectedBeatTypeCode !== '') {
      const btAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_TYPE']);
      if (btAttrib) returnObj[btAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatTypeCode;
    }

    const relAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'RELATED_UNRELATED']);
    if (relAttrib) returnObj[relAttrib.ATTRIB_KEY + '_0'] = this.selectedRelatedCode;

    const htkoAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'HTKO']);
    if (htkoAttrib) returnObj[htkoAttrib.ATTRIB_KEY + '_0'] = this.selectedHtkoCode;

    const fseAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'FSE']);
    if (fseAttrib) returnObj[fseAttrib.ATTRIB_KEY + '_0'] = this.selectedFsiCode;

    const stAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'SOURCE_TYPE']);
    if (stAttrib) returnObj[stAttrib.ATTRIB_KEY + '_0'] = this.selectedSourceTypeCode;

    const ptAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'PROJECT_TAGGING']);
    if (ptAttrib) returnObj[ptAttrib.ATTRIB_KEY + '_0'] = this.selectedProjectTaggingCode;

    const notesAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'NOTES']);
    if (notesAttrib) returnObj[notesAttrib.ATTRIB_KEY + '_0'] = this.selectedNotes;

    const ayAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'APPLICABLE_YEAR']);
    if (ayAttrib) returnObj[ayAttrib.ATTRIB_KEY + '_0'] = this.applicableYearKey;

    const lnAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'LINE_NO']);
    if (lnAttrib) returnObj[lnAttrib.ATTRIB_KEY + '_0'] = this.selectedLineNo;

    if (this.selectedBeatWithhold >= 0) {
      const bwAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_WITHHOLD']);
      if (bwAttrib) returnObj[bwAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatWithhold;
    }

    this.buildBaseFields(returnObj);

    if (this.newArray.indexOf('Method') > -1 && this.selectedMethodCode) {
      const mAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'METHOD']);
      if (mAttrib) returnObj[mAttrib.ATTRIB_KEY + '_0'] = this.selectedMethodCode.CODE_KEY;
    }
    if (this.newArray.indexOf('Base Level') > -1) {
      const blAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_LEVEL']);
      if (blAttrib) returnObj[blAttrib.ATTRIB_KEY + '_0'] = this.selectedBaseLevelCode;
    }
    if (this.newArray.indexOf('Base Entity Level') > -1) {
      const beAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_ENTITY_LEVEL']);
      if (beAttrib) returnObj[beAttrib.ATTRIB_KEY + '_0'] = this.selectedBaseEntityLevelCode;
    }

    if (!this.validateSave(returnObj)) return;

    const attribManagementChangeDetails = [returnObj];
    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      screen_key: this.globalParams.screen_key,
      tag_key: row.TAG_KEY,
      p_tax_year: this.curentyear,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };

    this.sendDetails(returnClobSettingsObj, attribManagementChangeDetails, 'Tag has been successfully saved/updated');
  }

  private sendDetails(settings: any, details: any[], message: string): void {
    this.ftcAttributeEditService.saveDefaults(
      this.GENERAL_CONFIG.base_url,
      this.globalParams,
      this.filterParams,
      settings,
      details,
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: any) => {
      if (result?.data?.errorMessage && result.data.errorMessage !== 'null') {
        this.isSaveClicked = false;
        this.gtwSnackbar.openSnackBar(result.data.errorMessage, 'gtw-snackbar--red', true, 4);
      } else {
        this.gtwSnackbar.openSnackBar(message, 'gtw-snackbar--green', true, 4);
        this.requestGridUpdate.emit('refresh');
      }
      this.cdr.detectChanges();
    });
  }

  private setAttribField(returnObj: any, displayName: string, attribName: string, value: any): void {
    if (this.newArray.indexOf(displayName) > -1) {
      const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', attribName]);
      if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = value;
    }
  }

  private buildBaseFields(returnObj: any): void {
    if (this.displaySingleSelectBase === 'true') {
      if (this.selectedBaseFdiiCodes != null && this.selectedBaseFdiiCodes !== '' && this.newArray.indexOf('Base FDII') > -1) {
        returnObj.BASE_FDII_DATA = this.selectedBaseFdiiCodes;
        const singleEx = _.find(this.basefdiiSingleMultiData, ['CODE_DESC', 'SINGLE']);
        if (singleEx) {
          const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_FDII']);
          if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = singleEx.CODE_KEY;
        }
      }
      if (this.selectedBaseBasketCode != null && this.selectedBaseBasketCode !== '' && this.newArray.indexOf('Base Basket') > -1) {
        returnObj.BASE_BASKET_DATA = this.selectedBaseBasketCode;
        const singleEx = _.find(this.baseBasketTypeData, ['CODE_DESCRIPTION', 'SINGLE']);
        if (singleEx) {
          const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_BASKET']);
          if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = singleEx.CODE_KEY;
        }
      }
    } else {
      if (this.newArray.indexOf('Base FDII') > -1 && Array.isArray(this.selectedBaseFdiiCodes)) {
        let baseFdiiSelected = '';
        for (const d of this.selectedBaseFdiiCodes) {
          if (d?.CODE_KEY != undefined) baseFdiiSelected += d.CODE_KEY + ',';
        }
        if (baseFdiiSelected) returnObj.BASE_FDII_DATA = baseFdiiSelected.substring(0, baseFdiiSelected.length - 1);
        this.setMultiSingleAllKey(returnObj, this.selectedBaseFdiiCodes, this.baseFDIIData, this.basefdiiSingleMultiData, 'BASE_FDII', 'CODE_DESC');
      }
      if (this.newArray.indexOf('Base Basket') > -1 && Array.isArray(this.selectedBaseBasketCode)) {
        let baseBasketSelected = '';
        for (const d of this.selectedBaseBasketCode) {
          if (d?.CODE_KEY != undefined) baseBasketSelected += d.CODE_KEY + ',';
        }
        if (baseBasketSelected) returnObj.BASE_BASKET_DATA = baseBasketSelected.substring(0, baseBasketSelected.length - 1);
        this.setMultiSingleAllKey(returnObj, this.selectedBaseBasketCode, this.baseBasketData, this.baseBasketTypeData, 'BASE_BASKET', 'CODE_DESCRIPTION');
      }
    }

    if (this.newArray.indexOf('Base Type') > -1 && Array.isArray(this.selectedBaseTypeCode)) {
      let baseTypeSelected = '';
      for (const d of this.selectedBaseTypeCode) {
        if (d?.CODE_KEY != undefined) baseTypeSelected += d.CODE_KEY + ',';
      }
      if (baseTypeSelected) returnObj.BASE_TYPE_DATA = baseTypeSelected.substring(0, baseTypeSelected.length - 1);
      this.setMultiSingleAllKey(returnObj, this.selectedBaseTypeCode, this.baseTypeData, this.baseTypeCodeData, 'BASE_TYPE', 'CODE_DESCRIPTION');
    }

    if (this.selectedMethodCode?.CODE_DESCRIPTION !== 'Allocate') {
      if (returnObj.BASE_FDII_DATA && this.baseFDIIData && returnObj.BASE_FDII_DATA.split(',').length === this.baseFDIIData.length) {
        returnObj.BASE_FDII_DATA = '';
      }
      if (returnObj.BASE_BASKET_DATA && this.baseBasketData && returnObj.BASE_BASKET_DATA.split(',').length === this.baseBasketData.length) {
        returnObj.BASE_BASKET_DATA = '';
      }
      if (returnObj.BASE_TYPE_DATA && this.baseTypeData && returnObj.BASE_TYPE_DATA.split(',').length === this.baseTypeData.length) {
        returnObj.BASE_TYPE_DATA = '';
      }
    }
  }

  private setMultiSingleAllKey(returnObj: any, selected: any[], allData: any[], typeData: any[], attribName: string, codeField: string): void {
    const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', attribName]);
    if (!attrib) return;
    if (selected?.length === 1) {
      const exists = _.find(typeData, [codeField, 'SINGLE']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected && allData && selected.length === allData.length) {
      const exists = _.find(typeData, [codeField, 'ALL']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected?.length > 1) {
      const exists = _.find(typeData, [codeField, 'MULTI']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    }
  }

  private validateSave(returnObj: any): boolean {
    if (this.newArray.indexOf('Base FDII') > -1 && this.displaySingleSelectBase === 'true' &&
        (this.selectedBaseFdiiCodes === '' || this.selectedBaseFdiiCodes == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base FDII', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Basket') > -1 && this.displaySingleSelectBase === 'true' &&
        (this.selectedBaseBasketCode === '' || this.selectedBaseBasketCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Basket', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base FDII') > -1 && Array.isArray(this.selectedBaseFdiiCodes) && this.selectedBaseFdiiCodes.length === 0) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base FDII', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Basket') > -1 && Array.isArray(this.selectedBaseBasketCode) && this.selectedBaseBasketCode.length === 0) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Basket', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Type') > -1 && Array.isArray(this.selectedBaseTypeCode) && this.selectedBaseTypeCode.length === 0) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Type', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Level') > -1 && (this.selectedBaseLevelCode === '' || this.selectedBaseLevelCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Level', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Entity Level') > -1 && (this.selectedBaseEntityLevelCode === '' || this.selectedBaseEntityLevelCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Entity Level', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Basket') > -1 && (this.selectedBasketCode === '' || this.selectedBasketCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Basket', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('FDII') > -1 && (this.selectedFdiiCode === '' || this.selectedFdiiCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select FDII', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Source Type') > -1 && (this.selectedSourceTypeCode === '' || this.selectedSourceTypeCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Source Type', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('SIC Code') > -1 && (this.selectedSicCode === '' || this.selectedSicCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select SIC Code', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if ((this.selectedBeatCodeDesc === 'Yes' && (this.selectedBeatWithhold === undefined || this.selectedBeatWithhold === '' || this.selectedBeatWithhold === null)) ||
        (this.selectedBeatWithhold && (this.selectedBeatWithhold < 0 || this.selectedBeatWithhold > 100))) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select BEAT Withhold between 0 to 100 only', 'gtw-snackbar--red', true, 5);
      return false;
    }
    return true;
  }

  /* ─── Reset (Edit mode) ─── */

  reset(): void {
    this.editCountCheckForActualData = 0;
    this.isResetClicked = true;
    this.tranCatgCount = 0;
    this.methodChangeCount = 0;
    this.editCount = 1;
    this.loadingData = true;
    this.resetOption = true;
    this.selectedBeatTypeCode = '';
    this.isMethodChangedManuallyEdit = false;
    this.getCodeMastData();
    this.getTransactionCategoriesData();
    this.getAttribMast();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  /* ─── Cancel ─── */

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  /* ─── Helpers ─── */

  getTradingPartnerList(): any[] {
    if ((this.selectedRelatedCodeDesc === 'Related Domestic' || this.selectedRelatedCodeDesc === '') &&
        (this.selectedBeatCodeDesc === 'No' || this.selectedBeatCodeDesc === '')) {
      return this.domesticTradingPartnerData;
    }
    if (this.selectedRelatedCodeDesc === 'Related Foreign' && this.selectedBeatCodeDesc === 'Yes') {
      return this.beatYesforeignTradingPartnerData;
    }
    if (this.selectedRelatedCodeDesc === 'Related Foreign' && (this.selectedBeatCodeDesc === 'No' || this.selectedBeatCodeDesc === '')) {
      return this.beatNoforeignTradingPartnerData;
    }
    return this.tradingPartnerCodeData;
  }

  rebuildTradingPartnerOptions(): void {
    this.tradingPartnerOptions = this.getTradingPartnerList().map((tp: any) => ({
      label: tp.LE_NAME,
      value: tp.COMBINATION_KEY,
    }));
    this.refreshFormDropdowns();
  }

  editCountCheckForActualAndMethod(): void {
    this.editCountCheckForActual();
    this.changeInCreateMethodEdit();
  }

  onDropdownFilterResult(key: string, event: any): void {
    this.dropdownLists[key] = event?.result || [];
  }

  private toAppkitOptions(items: any[]): any[] {
    return (items || []).map((item: any) => {
      item.showCheckbox = true;
      item.role = 'checkbox';
      return item;
    });
  }

  private syncDropdownList(key: string, master: any[]): void {
    this.dropdownLists[key] = this.toAppkitOptions(master).slice();
  }

  private uniqueData(arrayData: any[], filterBy: string): any[] {
    const elementIds: any[] = [];
    return arrayData.filter(el => {
      if (elementIds.indexOf(el[filterBy]) === -1) {
        elementIds.push(el[filterBy]);
        return true;
      }
      return false;
    });
  }
  private refreshFormDropdowns(): void {
    refreshNamedDropdown(this, 'transCategoryData', 'selectedTransCat', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'basketCodeData', 'selectedBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'sicCodeData', 'selectedSicCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'fdiiCodeData', 'selectedFdiiCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'filteredTaxYearData', 'applicableYearKey', 'CODE_DESC', 'CODE_KEY');
    refreshNamedDropdown(this, 'lineNoCodeData', 'selectedLineNo', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'yesNoData', 'selectedBeatCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'beatTypeData', 'selectedBeatTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'relatedCodeData', 'selectedRelatedCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'tradingPartnerOptions', 'selectedTradingPartnerCode', 'label', 'value');
    refreshNamedDropdown(this, 'countryCodeData', 'selectedCountryCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'htkoData', 'selectedHtkoCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'fsiData', 'selectedFsiCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'sourceTypeCodeData', 'selectedSourceTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'projectTagCodeData', 'selectedProjectTaggingCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'methodCodeData', 'selectedMethodCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseFDIIData', 'selectedBaseFdiiCodes', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'basketCodeAllocateData', 'selectedBaseBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseLevelData', 'selectedBaseLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseEntityData', 'selectedBaseEntityLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY');
  }

  onUpdateCountryFieldFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedTransCatItem', 'selectedTransCat', 'CODE_DESCRIPTION', 'CODE_KEY', 'transCategoryDataView', () => this.updateCountryField(true));
  }
  onChangeBasketCodeFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBasketCodeItem', 'selectedBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'basketCodeDataView', () => this.changeBasketCode());
  }
  onSelectedSicCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedSicCodeItem', 'selectedSicCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'sicCodeDataView');
  }
  onSelectedFdiiCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedFdiiCodeItem', 'selectedFdiiCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'fdiiCodeDataView');
  }
  onApplicableYearKeySelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'applicableYearKeyItem', 'applicableYearKey', 'CODE_DESC', 'CODE_KEY', 'filteredTaxYearDataView');
  }
  onSelectedLineNoSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedLineNoItem', 'selectedLineNo', 'CODE_DESCRIPTION', 'CODE_KEY', 'lineNoCodeDataView');
  }
  onChangeBeatCodeFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBeatCodeItem', 'selectedBeatCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'yesNoDataView', () => this.changeBeatCode());
  }
  onSelectedBeatTypeCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBeatTypeCodeItem', 'selectedBeatTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'beatTypeDataView');
  }
  onChangeRelatedCodeFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedRelatedCodeItem', 'selectedRelatedCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'relatedCodeDataView', () => this.changeRelatedCode());
  }
  onChangeTradingPartnerFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedTradingPartnerCodeItem', 'selectedTradingPartnerCode', 'label', 'value', 'tradingPartnerOptionsView', () => this.changeTradingPartner());
  }
  onSelectedCountryCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedCountryCodeItem', 'selectedCountryCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'countryCodeDataView');
  }
  onSelectedHtkoCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedHtkoCodeItem', 'selectedHtkoCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'htkoDataView');
  }
  onSelectedFsiCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedFsiCodeItem', 'selectedFsiCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'fsiDataView');
  }
  onSelectedSourceTypeCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedSourceTypeCodeItem', 'selectedSourceTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'sourceTypeCodeDataView');
  }
  onSelectedProjectTaggingCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedProjectTaggingCodeItem', 'selectedProjectTaggingCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'projectTagCodeDataView');
  }
  onEditCountCheckForActualFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedMethodCodeItem', 'selectedMethodCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'methodCodeDataView', () => this.editCountCheckForActualAndMethod());
  }
  onSelectedBaseFdiiCodesSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseFdiiCodesItem', 'selectedBaseFdiiCodes', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseFDIIDataView');
  }
  onSelectedBaseBasketCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseBasketCodeItem', 'selectedBaseBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'basketCodeAllocateDataView');
  }
  onSelectedBaseLevelCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseLevelCodeItem', 'selectedBaseLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseLevelDataView');
  }
  onSelectedBaseEntityLevelCodeSelect(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedBaseEntityLevelCodeItem', 'selectedBaseEntityLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'baseEntityDataView');
  }

  onDropdownSelectItem(_event: any): void {}

}
